import SubjectHeader from "../SubjectHeader/SubjectHeader";
import { useLocation } from "react-router-dom";
import ViewPage from "../ViewPage/ViewPage";

const StudentQuizResults = () => {
    const { state } = useLocation();    
    
    return (
        <div className="TestPageContainer quiz-results">
            <SubjectHeader headerName = {state?.title} backgroundColor={state?.backGroundColor} subCategory={state?.isQuestionBank ? state?.data?.filename : state?.data?.quizTitle} headerImage={state?.imageSrc} backNavigation={{ path: state?.backNavigation?.path, state: state?.backNavigation?.state }} tabName={state?.isQuestionBank ? 'Questions Bank' : 'Quiz'}/>
            <ViewPage data={ state?.data } isQuestionBank={state?.isQuestionBank}/>
        </div>
    )
}

export default StudentQuizResults;
